import { useEffect, useRef } from "react";

/**
 * Adds .is-visible to .in-view children when they enter the viewport.
 * Drop on any container; children with className "in-view" will animate.
 */
export const useScrollReveal = (selector = ".in-view", deps = []) => {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current || document;
    const items = root.querySelectorAll(selector);
    if (!items.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    items.forEach((el, i) => {
      el.style.transitionDelay = `${Math.min(i * 60, 360)}ms`;
      io.observe(el);
    });

    return () => io.disconnect();
  }, [selector, JSON.stringify(deps)]);

  return ref;
};

export default useScrollReveal;
